import type { Secret } from "@/lib/api";
import { IconButton } from "@/components/common/IconButton";
import {
	ResourceDetail,
	ResourceDetails,
	ResourceRow,
	ResourceTag,
	ResourceTitle,
} from "@/components/common/ResourceCard";
import { formatRelativeDateTime } from "@/lib/format-datetime";

/** シークレット 1 件の行。名前 (環境変数名)・許可ホスト・更新日時を示す。値は表示しない。 */
export function SecretRow({
	secret,
	onEdit,
	onDelete,
}: {
	secret: Secret;
	onEdit: () => void;
	onDelete: () => void;
}) {
	return (
		<ResourceRow
			testId={`secret-row-${secret.id}`}
			compact
			title={
				<ResourceTitle compact mono>
					{secret.name}
				</ResourceTitle>
			}
			actions={
				<>
					<span
						style={{
							// 「今日 HH:mm」と年月日入りの表記が混ざっても、行ごとに左端が揃うよう最長の表記の幅を確保する。
							minWidth: "calc(4em + 17ch)",
							marginRight: 12,
							fontSize: "var(--text-caption)",
							fontVariantNumeric: "tabular-nums",
							color: "var(--fg-3)",
							whiteSpace: "nowrap",
						}}
					>
						最終更新 {formatRelativeDateTime(secret.updatedAt)}
					</span>
					<IconButton
						icon="pencil"
						size={28}
						title="値・許可ホストを編集"
						data-testid={`secret-edit-${secret.id}`}
						onClick={onEdit}
					/>
					<IconButton
						icon="trash"
						size={28}
						hoverColor="var(--danger)"
						title="シークレットを削除"
						data-testid={`secret-delete-${secret.id}`}
						onClick={onDelete}
					/>
				</>
			}
		>
			<ResourceDetails>
				<ResourceDetail label="許可ホスト">
					{secret.allowedHosts.map((host) => (
						<ResourceTag key={host} mono>
							{host}
						</ResourceTag>
					))}
				</ResourceDetail>
			</ResourceDetails>
		</ResourceRow>
	);
}
